import { EventEmitter, Injectable } from '@angular/core';

@Injectable()
export class SharedService {
    logUpdate = new EventEmitter<any>();
    updatePeriodGone = new EventEmitter<any>();
    login = new EventEmitter<any>();
    httpUpdate = new EventEmitter<any>();
    collectionUpdated = new EventEmitter<any>();
    projectChanged = new EventEmitter<any>();
}



// WEBPACK FOOTER //
// ./src/services/sharedService.ts